(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* ---- 1. Hash pe card tak scroll ---- */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    /* ---- 1b. Sticky sidebar fix ---- */
    const sidebar = document.querySelector('.collection-layout__sidebar--sticky');
    if (sidebar) {
      /* Sirf overflow: hidden wale parents ko clip karte hain (sticky nahi todta).
         auto/scroll wale parents (jo page ko scroll karte hain) ko bilkul nahi chhedte. */
      let node = sidebar.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        const cs = getComputedStyle(node);
        const scrolls = cs.overflowY === 'auto' || cs.overflowY === 'scroll' || cs.overflowX === 'auto' || cs.overflowX === 'scroll';
        if (!scrolls && (cs.overflowX === 'hidden' || cs.overflowY === 'hidden')) {
          node.style.overflow = 'clip';
        }
        node = node.parentElement;
      }

      /* Sticky header ho to uske neeche se sidebar chipke */
      const gap = Number(sidebar.dataset.stickyGap || 24);
      const stickyHeader = (() => {
        let el = document.querySelector('header-component, header, #header-group');
        while (el && el !== document.body) {
          const pos = getComputedStyle(el).position;
          if (pos === 'sticky' || pos === 'fixed') return el;
          el = el.parentElement;
        }
        return null;
      })();

      let ticking = false;
      const update = () => {
        ticking = false;
        const bottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
        sidebar.style.setProperty('--sticky-top', Math.round(bottom + gap) + 'px');
      };
      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      };
      update();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }

    /* ---- 2. Filters panel: desktop pe open, mobile pe collapsed ---- */
    const mq = window.matchMedia('(min-width: 990px)');
    document.querySelectorAll('[data-filters-panel]').forEach((panel) => {
      const sync = () => { panel.open = mq.matches; };
      sync();
      mq.addEventListener('change', sync);
    });

    /* ---- 3. Filters auto-apply ---- */
  let filterTimer;

  const submitCollectionFilters = (form) => {
    if (!form || form.id !== 'CollectionFiltersForm') return;

    const layout = form.closest('.collection-layout') ||
      document.querySelector('.collection-layout');

    layout?.classList.add('is-loading');
    form.requestSubmit();
  };

  // Checkbox, availability aur sort dropdown
  document.addEventListener('change', (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement ||
          target instanceof HTMLSelectElement)) return;

    const form = target.form ||
      target.closest('#CollectionFiltersForm');

    if (!form || form.id !== 'CollectionFiltersForm') return;

    // Price inputs are submitted after the user finishes editing the range.
    if (target.matches('[data-price-input]')) return;

    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => {
      submitCollectionFilters(form);
    }, 150);
  });

  // Price range: do not submit while the user is still typing.
  // This lets the user enter both minimum and maximum before the page reloads.
  document.addEventListener('input', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('[data-price-input]')) return;

    const form = target.form || target.closest('#CollectionFiltersForm');
    if (!form || form.id !== 'CollectionFiltersForm') return;

    clearTimeout(filterTimer);
  });

  // Submit once focus leaves the whole price range, not when moving
  // from the minimum field to the maximum field.
  document.addEventListener('focusout', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('[data-price-input]')) return;

    const form = target.form || target.closest('#CollectionFiltersForm');
    if (!form || form.id !== 'CollectionFiltersForm') return;

    clearTimeout(filterTimer);
    filterTimer = setTimeout(() => {
      const active = document.activeElement;
      if (active && active.matches && active.matches('[data-price-input]')) return;
      submitCollectionFilters(form);
    }, 120);
  });

  // Enter in either price field applies the latest values immediately.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('[data-price-input]')) return;

    const form = target.form || target.closest('#CollectionFiltersForm');
    if (!form || form.id !== 'CollectionFiltersForm') return;

    event.preventDefault();
    clearTimeout(filterTimer);
    submitCollectionFilters(form);
  });

  // Loading state
  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== 'CollectionFiltersForm') return;

    const layout = form.closest('.collection-layout') ||
      document.querySelector('.collection-layout');

    layout?.classList.add('is-loading');
  });


    /* ---- 4. Quick add ---- */
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      const wrapper = btn.closest('[data-cart-add-url]');
      const addUrl = wrapper ? wrapper.dataset.cartAddUrl : '/cart/add.js';
      const label = btn.querySelector('.pcard__quick-label');
      const original = label.textContent;
      btn.disabled = true;
      label.textContent = 'Adding…';
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        const data = await res.json();
        label.textContent = 'Added';
        /* Theme ka cart drawer / count refresh karne ke liye event */
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: data.items } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        label.textContent = 'Try again';
      }
      setTimeout(() => {
        label.textContent = original;
        btn.disabled = false;
      }, 1800);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
